<script setup lang="ts">
  import SearchResultGroup from './search-result-group.vue'

  defineProps<{
    vouchers: SearchVoucher[],
  }>()
</script>

<template>
  <search-result-group
    v-slot="{ item: voucher }"
    :items="vouchers"
    route-list="voucher list"
    route-detail="voucher detail"
    name="Voucher">
    <div class="text-sm font-medium">
      {{ voucher.title }}
    </div>
    <div class="mb-1 text-xs text-gray-500">
      {{ voucher.code }}
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <fa-icon
        class="text-gray-500"
        icon="i-far-eye" />
      <div>{{ voucher.views }} dilihat</div>
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon
          class="text-gray-500"
          icon="i-far-ticket" />
      </div>
      <div>{{ voucher.stock ?? 'Unlimited' }} stok</div>
    </div>
  </search-result-group>
</template>
